module.exports = __webpack_public_path__ + "img/8ddab47.png";